export default "__VITE_ASSET__D7k2FWXB__"